import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from 'home/Home.vue'
import Cookies from 'legalPath/Cookies.vue'
import Privacy from 'legalPath/Privacy.vue'
import Terms from 'legalPath/Terms.vue'
import Sitemap from 'legalPath/Sitemap.vue'
import AccessibilityStatement from 'legalPath/AccessibilityStatement.vue'
import PrintJourney from '../components/PrintJourney.vue'
import Journey from '../views/Journey.vue'
import Results from '../views/Results.vue'
import JourneyViewedMiddleware from '../http/journey-middleware'

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
    },
    {
        path: '/search/:hash/results',
        name: 'Results',
        component: Results,
    },
    {
        path: '/search/:hash/results/:journeyId',
        name: 'Journey',
        component: Journey,
    },
    {
        path: '/search/:hash/results/:journeyId/print',
        name: 'PrintJourney',
        component: PrintJourney,
    },
    {
        path: '/about',
        name: 'About',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
    },
    {
        path: '/privacy-policy',
        name: 'Privacy',
        component: Privacy,
    },
    {
        path: '/terms-and-conditions',
        name: 'Terms',
        component: Terms,
    },
    {
        path: '/cookie-policy',
        name: 'Cookies',
        component: Cookies,
    },
    {
        path: '/site-map',
        name: 'Sitemap',
        component: Sitemap,
    },
    {
        path: '/accessibility-statement',
        name: 'AccessibilityStatement',
        component: AccessibilityStatement,
    },
];

const router = new VueRouter({
    mode: 'history',
    routes,
    scrollBehavior(to, from, savedPosition) { // eslint-disable-line
        return { x: 0, y: 0 }
    },
});

router.beforeEach(JourneyViewedMiddleware)

export default router;
